import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { PARITY_URL } from 'app/@common/constants'


export default function SelectMarkets({ ...props }) {

    const myProps = {
        urlAjax: PARITY_URL.MARKET,
        placeholder: 'All markets',
        icon: { icon: 'globe-europe' },
        isMulti: true,
        isClearable: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}